export default __webpack_public_path__ + "static/MySalonSuite-39a05ce6da56739e3cc7334f072f9743.png";